import TreeGrid from './src/tree-grid.vue'
TreeGrid.install = function (Vue) {
  Vue.component(TreeGrid.name, TreeGrid)
}
export default TreeGrid



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/treeGrid/index.js